import Analytics from '@module/analytics';

const session = window['__session__'];

export const createDefaultPayload = () => {
  const dataLayerPayload = {};

  if (typeof session !== 'undefined') {
    dataLayerPayload.user = {
      account_type: session.user && session.user.id ? 'plus' : 'free',
      language: session.user && session.user.language,
      subdomain_name:
        session.profile && session.profile.subdomain_name
          ? session.profile.subdomain_name
          : null,
    };
  }
  // Preloaded transfer
  if (window._preloaded_transfer_) {
    const transfer = window._preloaded_transfer_;
    // Download page data
    dataLayerPayload.page = {
      download: {
        id: transfer.id,
        receiver_id: transfer.recipient_id,
        security_hash: transfer.security_hash,
        state: transfer.state,
      },
    };
    // VRL
    if (transfer.items && transfer.items.length) {
      dataLayerPayload.page.VRL = transfer.items.some(
        ({ previewable }) => previewable
      );
      dataLayerPayload.transfer = {
        spaceship_transfer: transfer.id.charAt(0) === 's',
        item_count: transfer.items.length,
        previewable_count: transfer.items.reduce((sum, { previewable }) => {
          return previewable ? sum + 1 : sum;
        }, 0),
      };
    }
  }
  // Fake data layer because everytime dataLayer.push is invoked, it's one extra event
  // As versus this approach, where the dataLayer is rather initialised with data
  return dataLayerPayload;
};

export const analyticsInit = () => {
  // Configure Analytics
  Analytics.configure({
    domain: session.settings.cookie_domain,
    name: 'wt_tandc',
    value: '20180508',
  });

  Analytics.pushDataLayerEvent(createDefaultPayload());

  Analytics.pushDataLayerEvent({
    event: 'termsAccepted',
    virtualPagePath: `${location.pathname}${location.search}`,
    virtualPageLocation: `${location}`,
  });

  // If the user has already accepted our cookie, we can
  // immediately enable the Analytics.
  if (Analytics.hasAccepted()) {
    Analytics.enable();
  }
};

analyticsInit();
